import { useState } from 'react';
import api from '../../services/api';
import { API } from '../../App';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogFooter } from '../ui/dialog';
import { toast } from 'sonner';
import { Lock } from 'lucide-react';

// Asks the signed-in super admin to re-enter THEIR OWN password. On success the server returns a
// single-use, 5-minute token that the caller sends with the protected MFA setting change.
const MfaPasswordUnlock = ({ open, onOpenChange, onUnlocked }) => {
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);

  const close = () => {
    setPassword('');
    onOpenChange(false);
  };

  const submit = async () => {
    if (!password) return;
    setBusy(true);
    try {
      const res = await api.post(`${API}/admin/mfa/unlock`, { password });
      const token = res.data.token;
      setPassword('');
      onOpenChange(false);
      onUnlocked(token);
    } catch (error) {
      toast.error(error?.response?.data?.detail || 'Could not confirm your password');
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(next) => { if (!next) { close(); } else { onOpenChange(true); } }}>
      <DialogContent className="bg-white max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Lock className="w-5 h-5 text-blue-600" />
            Confirm your password
          </DialogTitle>
          <DialogDescription>
            This MFA setting is protected. Enter your own super admin password to unlock it for 5 minutes. The unlock is used once.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-2 py-2">
          <Label htmlFor="mfa-unlock-password">Your password</Label>
          <Input
            id="mfa-unlock-password"
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onKeyDown={(e) => { if (e.key === 'Enter') submit(); }}
            data-testid="mfa-unlock-password"
            autoFocus
          />
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={close}>Cancel</Button>
          <Button onClick={submit} disabled={!password || busy} style={{ backgroundColor: '#ee7203', color: 'white' }} data-testid="mfa-unlock-submit">
            {busy ? 'Checking...' : 'Unlock'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default MfaPasswordUnlock;
